import React  from 'react'
import Spinner from '../../Spinner/spinner';
import { ToastContainer} from "react-toastify";
import NumberInput from '../../../Component/PhoneInput/phoneInput';
import UseAddTeam from './Hooks/useAddTeam';


const AddTeam = () => {
    const {
        spinner,
        teamAdd
    }=UseAddTeam()
    return (
        <>
            <ToastContainer />
            <section>
                <div className="cus-padd cusheight">
                    {spinner ? <Spinner /> : null}
                    <header>
                        <h2 className='page-tittle'>
                            Add Team
                        </h2>
                        <hr />
                    </header>
                    <form className="row g-3 mt-4" onSubmit={teamAdd.handleSubmit}>
                        <div className="col-md-6">
                            <label htmlFor="recipient-name" className="col-form-label">Name *</label>
                            <input type="text" className="form-control"
                                id="recipient-name"
                                name='name'
                                onChange={teamAdd.handleChange}
                                value={teamAdd.values.name}
                            />
                            {teamAdd.touched.name && teamAdd.errors.name ? (
                                <div style={{ color: "red", fontSize: "13px" }}>
                                    {teamAdd.errors.name}
                                </div>
                            ) : null}
                        </div>
                        <div className="col-md-6">
                            <label htmlFor="recipient-name" className="col-form-label">Email *</label>
                            <input type="text" className="form-control"
                                id="recipient-name"
                                name='email'

                                onChange={teamAdd.handleChange}
                                value={teamAdd.values.email}
                            />
                            {teamAdd.touched.email && teamAdd.errors.email ? (
                                <div style={{ color: "red", fontSize: "13px" }}>
                                    {teamAdd.errors.email}
                                </div>
                            ) : null}
                        </div>
                        <div className="col-md-6">
                            <label htmlFor="recipient-name" className="col-form-label">Mobile Number *</label>
                            {/* <input type="number" className="form-control"
                                id="recipient-name"
                                maxLength={10}
                                name='mobileNo'
                                onChange={teamAdd.handleChange}
                                value={teamAdd.values.mobileNo}
                                onInput={(e) => { if (e.target.value.length > e.target.maxLength) e.target.value = e.target.value.slice(0, e.target.maxLength); }}

                            /> */}
                            <NumberInput
                                width={false}
                                Require={false}
                                Name="mobileNo"
                                HandleChange={teamAdd}
                                Value={teamAdd.values.mobileNo}
                            />
                            {teamAdd.touched.mobileNo && teamAdd.errors.mobileNo ? (
                                <div style={{ color: "red", fontSize: "13px" }}>
                                    {teamAdd.errors.mobileNo}
                                </div>
                            ) : null}
                        </div>
                        <div>
                            <button type="submit" className="btn btn-primary col-0">Submit</button>
                        </div>
                    </form>
                </div>



            </section>
        </>
    )
}

export default AddTeam